import { ArrowLeft } from '@phosphor-icons/react';

import pt from '../../locales/pt';
import { useAiSessionsQuery } from '../../features/ai/queries';
import { formatRelativeTimePt } from '../../utils/formatRelativeTimePt';
import { cn } from '../../utils/cn';

/**
 * Lista de conversas guardadas do Evolution AI.
 */
export function EvolutionAiHistoryPanel({ onSelectSession, onBack, className }) {
  const { data: sessions = [], isLoading, isError } = useAiSessionsQuery({
    refetchOnMount: 'always',
  });

  return (
    <div className={cn('flex min-h-0 flex-1 flex-col', className)}>
      <div className="mb-4 flex items-center gap-2">
        <button
          type="button"
          onClick={onBack}
          className="flex h-9 w-9 items-center justify-center rounded-full border border-border text-muted-foreground transition hover:bg-muted"
          aria-label={pt.evolutionAi.backToChat}
        >
          <ArrowLeft className="h-4 w-4" aria-hidden />
        </button>
        <h3 className="font-display text-lg font-semibold text-foreground">
          {pt.evolutionAi.historyTitle}
        </h3>
      </div>

      {isLoading ? (
        <p className="text-sm text-muted-foreground">{pt.common.loading}</p>
      ) : null}

      {isError ? (
        <p className="text-sm text-muted-foreground">{pt.evolutionAi.error}</p>
      ) : null}

      {!isLoading && !isError && !sessions.length ? (
        <div className="rounded-2xl border border-dashed border-border bg-background px-4 py-8 text-center">
          <p className="font-medium text-muted-foreground">{pt.evolutionAi.historyEmpty}</p>
          <p className="mt-1 text-sm text-muted-foreground">{pt.evolutionAi.historyEmptyHint}</p>
        </div>
      ) : null}

      {!isLoading && !isError && sessions.length ? (
        <ul className="overflow-hidden rounded-2xl border border-border bg-card">
          {sessions.map((session, index) => (
            <li
              key={session.id}
              className={cn(index > 0 && 'border-t border-border')}
            >
              <button
                type="button"
                onClick={() => onSelectSession(session.id)}
                className="flex w-full flex-col gap-1 px-4 py-3.5 text-left transition hover:bg-muted"
              >
                <span className="line-clamp-2 text-sm font-medium leading-snug text-foreground">
                  {session.title || pt.evolutionAi.untitledSession}
                </span>
                <span className="text-xs text-muted-foreground">
                  {formatRelativeTimePt(session.updated_at || session.created_at)}
                </span>
              </button>
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
}
